<template>
    <div class="container">
        <b-modal
            :model-value="modAsociaMenu"
            :no-close-on-backdrop="true"
            hide-footer
            centered
            size="xl"
            dialog-class="modal-asocia-menu-wide"
            :title="nombreRol || ''"
            header-class="reset-modal-header"
            title-class="reset-modal-title"
            body-class="reset-modal-body"
            class="reset-password-dialog modal-fixed-height"
            @hide="cierraModal"
        >
            <div class="uniform-modal-body uniform-modal-body--wide">
                <div class="password-policy-box mb-4">
                    <div class="password-policy-title">{{ labels.infoTitle }}</div>
                    <div class="password-policy-subtitle">{{ labels.infoText }}</div>
                </div>
                <div class="menu-association-layout">
                    <div class="menu-sidebar">
                        <div class="menu-sidebar-title">{{ labels.menuListTitle }}</div>
                        <div class="menu-sidebar-list">
                            <b-button
                              v-for="menu in listadoMenus"
                              :key="menu.id"
                              @click="listaSubmenu(menu?.id)"
                              class="menu-sidebar-item"
                              :class="{ active: selectedMenuId === menu.id }"
                            >
                              {{ menu?.nombre }}
                            </b-button>
                        </div>
                    </div>
                    <div class="menu-content">
                        <div class="menu-content-title">{{ nombreMenu?.nombre || labels.selectMenuHint }}</div>
                        <div class="submenu-box" v-if="listadoSubMenus?.length > 0">
                            <div
                              v-for="submenu in listadoSubMenus"
                              :key="submenu?.id"
                              class="submenu-row d-flex align-items-center justify-content-between"
                            >
                                <div class="submenu-name">{{ submenu?.nombre }}</div>
                                <!-- ===== TOGGLE PERSONALIZADO PEQUEÑO ===== -->
                                <div class="custom-toggle-wrapper custom-toggle-sm">
                                    <input
                                        type="checkbox"
                                        :id="'toggle-' + submenu.id"
                                        v-model="submenuSelect"
                                        :value="submenu.id"
                                        @change="asociaSubMenu(submenu.id)"
                                        :checked="submenuSelect.includes(submenu.id)"
                                    />
                                    <label :for="'toggle-' + submenu.id" class="toggle-label">
                                        <span class="toggle-slider"></span>
                                        <span class="toggle-text">
                                            {{ submenuSelect.includes(submenu.id) ? labels.active : labels.inactive }}
                                        </span>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="no-submenus" v-if="showRow">
                            {{ labels.noRow }}
                        </div>
                    </div>
                </div>
                <div class="reset-dialog-actions d-flex justify-content-end mt-4 uniform-actions-wrap">
                    <!-- ===== BOTÓN CERRAR CON MISMO ESTILO QUE EL DE REFERENCIA ===== -->
                    <b-button class="mr-2 reset-btn-secondary" @click="cierraModal">
                        {{ labels.close }}
                    </b-button>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
import Submenu from '../../services/SubMenu'; 
import Menu from '../../services/Menu'; 
import Roles from '../../services/Roles'; 
import RoleMenu from '../../services/RoleMenu'; 

export default {
    name: "ModalAsociaMenu",
    props: ['modAsociaMenu', 'IdRol'],
    data: () => ({
        listadoMenus: [],
        listadoSubMenus: [],
        listadoSubMenusAsoc: [],
        submenuSelect: [],
        nombreRol: "",
        nombreMenu: "",
        menuSelected: "",
        selectedMenuId: null,
        showRow: false,
    }),
    computed: {
        labels() {
            if (this.$store.state._language == "es-ES") { 
                return {
                    save: "Guardar",
                    close: "Cerrar",
                    noRow: "No hay submenús disponibles",
                    active: "Activo",
                    inactive: "Inactivo",
                    infoTitle: "Asociación de menús",
                    infoText: "Selecciona un menú de la barra lateral y activa o desactiva sus submenús.",
                    menuListTitle: "Menús",
                    selectMenuHint: "Selecciona un menú"
                }
            } else {
                return {
                    save: "Save",
                    close: "Close",
                    noRow: "There are no submenus available",
                    active: "Active",
                    inactive: "Inactive",
                    infoTitle: "Menu association",
                    infoText: "Select a menu from the sidebar and toggle its submenus for the role.",
                    menuListTitle: "Menus",
                    selectMenuHint: "Select a menu"
                }
            }
        }
    },
    methods: {
        nameRol() {
            if (this.IdRol && this.IdRol != "") { 
                Roles.getAllRolesById(this.IdRol) 
                    .then((res) => { 
                        this.nombreRol = res.data.rolById[0]?.nombre || "" 
                    })
                    .catch((error) => { 
                        console.log(error) 
                    }) 
            }
        },
        listaSubmenu(idMenu) {
            if (!this.IdRol) {
                console.error('IdRol está vacío o es undefined');
                this.$toast.error('No se pudo obtener el ID del rol');
                return;
            }
            
            if (!idMenu) {
                console.error('idMenu está vacío o es undefined');
                return;
            }

            const idRolNumerico = Number(this.IdRol);
            const idMenuNumerico = Number(idMenu);
            
            console.log('Llamando a getSubMenuByRolByMenu con:', { 
                idRol: idRolNumerico, 
                idMenu: idMenuNumerico,
                idRolOriginal: this.IdRol,
                idMenuOriginal: idMenu
            });
            
            this.selectedMenuId = idMenu;
            this.menuSelected = idMenu;
            
            Submenu.subMenuByIdMenu(idMenuNumerico)
                .then((res) => {
                    this.listadoSubMenus = res.data.listSubMenu || [];
                    this.showRow = this.listadoSubMenus.length === 0;
                })
                .catch((error) => {
                    console.log('Error en subMenuByIdMenu:', error);
                });

            RoleMenu.getSubMenuByRolByMenu(idRolNumerico, idMenuNumerico)
                .then((res) => {
                    console.log('Respuesta de getSubMenuByRolByMenu:', res.data);
                    let submenuChecked = [];
                    this.listadoSubMenusAsoc = res.data.listRolMenu || [];
                    this.listadoSubMenusAsoc.forEach((elem) => {
                        submenuChecked.push(elem.id_submenu);
                    });
                    this.submenuSelect = submenuChecked;
                })
                .catch((error) => {
                    console.error('Error en getSubMenuByRolByMenu:', error);
                    console.error('Detalles del error:', error.response?.data || error.message);
                    this.$toast.error('Error al cargar los submenús asociados');
                });

            this.nombreMenu = this.listadoMenus.find((lm) => lm.id == idMenu);
        },
        asociaSubMenu(subMenuId) {
            if (!this.IdRol || !this.menuSelected || !subMenuId) {
                this.$toast.error('Faltan datos para asociar el submenú');
                return;
            }

            let datos = {
                idRol: Number(this.IdRol),
                idMenu: Number(this.menuSelected),
                idSubmenu: Number(subMenuId)
            };

            console.log('Enviando datos para asociar:', datos);

            RoleMenu.updateAsociacionRolemenu(datos) 
                .then((res) => { 
                    this.$toast.success(res.data.message || 'Submenú asociado correctamente'); 
                })
                .catch((err) => { 
                    console.error('Error al asociar submenú:', err);
                    this.$toast.error('Error al asociar el submenú');
                }) 
        },
        cierraModal() {
            this.listadoSubMenus = [] 
            this.submenuSelect = []
            this.selectedMenuId = null
            this.menuSelected = ""
            this.nombreMenu = "" 
            this.showRow = false
            this.$emit('closeModal', false) 
        }
    },
    watch: {
        IdRol: {
            immediate: true,
            handler(newVal) {
                if (newVal) {
                    this.nameRol()
                }
            }
        },
        modAsociaMenu: {
            handler(newVal) {
                if (newVal && this.IdRol && this.listadoMenus.length > 0 && !this.selectedMenuId) {
                    this.listaSubmenu(this.listadoMenus[0].id)
                }
            }
        }
    },
    mounted() {
        Menu.getAllMenu() 
            .then((res) => { 
                this.listadoMenus = res.data.listMenu || [] 
                if (this.modAsociaMenu && this.IdRol && this.listadoMenus.length > 0) {
                    this.listaSubmenu(this.listadoMenus[0].id)
                }
            })
            .catch((error) => { 
                console.log(error) 
            }) 
    }
}
</script>

<style scoped>
/* ===== BOTÓN CERRAR (X) - POSICIONADO DENTRO DEL MODAL ===== */
.modal-close-btn {
    position: absolute;
    top: 12px;
    right: 12px;
    z-index: 9999; /* Se asegura de estar por encima de todo */
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background-color: white;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: #2e507a; /* Color azul del título */
    box-shadow: 0 1px 3px rgba(0,0,0,0.2);
    transition: all 0.2s ease;
    padding: 0;
    margin: 0;
}

.modal-close-btn:hover {
    background-color: #f0f0f0;
    color: #1f3f62;
    box-shadow: 0 2px 5px rgba(0,0,0,0.25);
}

.modal-close-btn:active {
    transform: scale(0.95);
}

.modal-close-btn svg {
    width: 18px;
    height: 18px;
    display: block;
}

/* ===== MODAL CON ALTURA FIJA ===== */
.modal-fixed-height .modal-dialog {
    max-height: 90vh;
}

.modal-fixed-height .modal-content {
    max-height: 90vh;
    overflow: hidden;
    position: relative; /* IMPORTANTE: esto hace que el position:absolute del botón se ancle al modal */
}

.modal-fixed-height .modal-body {
    overflow: hidden;
    padding: 24px 20px;
}

/* ===== TOGGLE PERSONALIZADO - TAMAÑO PEQUEÑO ===== */
.custom-toggle-wrapper {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
}

.custom-toggle-wrapper input[type="checkbox"] {
    display: none;
}

.custom-toggle-wrapper .toggle-label {
    display: flex;
    align-items: center;
    gap: 6px;
    cursor: pointer;
    user-select: none;
    margin: 0;
}

/* Tamaño pequeño (default) */
.custom-toggle-wrapper .toggle-slider {
    position: relative;
    display: inline-block;
    width: 34px;
    height: 20px;
    background-color: #ccc;
    border-radius: 10px;
    transition: background-color 0.3s ease;
    flex-shrink: 0;
    box-shadow: inset 0 1px 2px rgba(0,0,0,0.15);
}

.custom-toggle-wrapper .toggle-slider::after {
    content: '';
    position: absolute;
    top: 2px;
    left: 2px;
    width: 16px;
    height: 16px;
    background-color: white;
    border-radius: 50%;
    transition: transform 0.3s ease;
    box-shadow: 0 1px 2px rgba(0,0,0,0.25);
}

.custom-toggle-wrapper input[type="checkbox"]:checked + .toggle-label .toggle-slider {
    background-color: #2e507a;
}

.custom-toggle-wrapper input[type="checkbox"]:checked + .toggle-label .toggle-slider::after {
    transform: translateX(14px);
}

.custom-toggle-wrapper input[type="checkbox"]:disabled + .toggle-label {
    opacity: 0.6;
    cursor: not-allowed;
}

.custom-toggle-wrapper .toggle-text {
    font-size: 12px;
    font-weight: 500;
    color: #495057;
    min-width: 48px;
    text-align: left;
}

/* ===== ESTILOS DEL MODAL ===== */
.uniform-modal-body--wide {
    padding: 8px 4px 4px 4px;
    height: 100%;
    display: flex;
    flex-direction: column;
}

.password-policy-box {
    background: white;
    border-radius: 8px;
    padding: 16px 20px;
    border-left: 4px solid #2e507a;
    box-shadow: 0 1px 3px rgba(0,0,0,0.1);
    flex-shrink: 0;
}

.password-policy-title {
    font-weight: 600;
    font-size: 15px;
    color: #2e507a;
    margin-bottom: 4px;
}

.password-policy-subtitle {
    font-size: 13px;
    color: #6c757d;
}

/* ===== LAYOUT MENÚ - ALTURA FIJA ===== */
.menu-association-layout {
    display: flex;
    gap: 20px;
    height: 380px;
    min-height: 380px;
    max-height: 380px;
    background: white;
    border-radius: 8px;
    overflow: hidden;
    border: 1px solid #e9ecef;
    flex-shrink: 0;
}

.menu-sidebar {
    flex: 0 0 220px;
    background: #f8f9fa;
    border-right: 1px solid #e9ecef;
    padding: 12px 0;
    overflow: hidden;
    display: flex;
    flex-direction: column;
}

.menu-sidebar-title {
    font-size: 13px;
    font-weight: 600;
    color: #6c757d;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    padding: 0 16px 10px 16px;
    border-bottom: 1px solid #e9ecef;
    margin-bottom: 6px;
    flex-shrink: 0;
}

.menu-sidebar-list {
    flex: 1;
    overflow-y: auto;
    overflow-x: hidden;
}

.menu-sidebar-item {
    display: block;
    width: 100%;
    text-align: left;
    padding: 10px 16px;
    background: transparent;
    border: none;
    border-radius: 0;
    color: #495057;
    font-size: 14px;
    font-weight: 500;
    transition: all 0.2s;
    cursor: pointer;
}

.menu-sidebar-item:hover {
    background: #e9ecef;
    color: #2e507a;
}

.menu-sidebar-item.active {
    background: #2e507a;
    color: white;
}

.menu-sidebar-item.active:hover {
    background: #1f3f62;
}

.menu-content {
    flex: 1;
    padding: 16px 20px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    min-width: 0;
}

.menu-content-title {
    font-size: 16px;
    font-weight: 600;
    color: #2e507a;
    padding-bottom: 12px;
    border-bottom: 2px solid #f0f2f5;
    margin-bottom: 12px;
    flex-shrink: 0;
}

.submenu-box {
    flex: 1;
    overflow-y: auto;
    overflow-x: hidden;
}

.submenu-row {
    padding: 8px 12px;
    border-bottom: 1px solid #f0f2f5;
    transition: background 0.2s;
}

.submenu-row:hover {
    background: #f8f9fa;
}

.submenu-row:last-child {
    border-bottom: none;
}

.submenu-name {
    font-size: 14px;
    color: #212529;
    font-weight: 500;
    padding-right: 16px;
    word-break: break-word;
}

.no-submenus {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    min-height: 100px;
    color: #6c757d;
    font-size: 14px;
    text-align: center;
}

/* ===== BOTONES - MISMO ESTILO QUE EL DE REFERENCIA ===== */
.uniform-actions-wrap {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    margin-top: 20px;
    padding-top: 16px;
    border-top: 1px solid #e9ecef;
    flex-shrink: 0;
}

/* Botón Cerrar - exactamente igual al de referencia */
.reset-btn-secondary {
    background-color: #f8f9fa !important;
    border: 1px solid #ced4da !important;
    color: #495057 !important;
    padding: 8px 24px;
    border-radius: 6px;
    font-weight: 500;
    transition: all 0.2s ease;
}

.reset-btn-secondary:hover:not(:disabled) {
    background-color: #e9ecef !important;
    border-color: #adb5bd !important;
    color: #495057 !important;
}

.reset-btn-secondary:focus,
.reset-btn-secondary:active {
    box-shadow: none !important;
    outline: none !important;
}

.reset-btn-secondary:disabled {
    opacity: 0.65;
    cursor: not-allowed;
}

/* ===== ESTILOS DEL HEADER DEL MODAL ===== */
.reset-modal-header {
    background-color: #2e507a;
    color: white;
    padding: 16px 20px;
    border-radius: 8px 8px 0 0;
}

.reset-modal-title {
    font-size: 18px;
    font-weight: 600;
    margin: 0;
}

.reset-modal-body {
    padding: 24px 20px;
    background-color: #f8f9fa;
    overflow: hidden;
}

/* ===== SCROLLBAR ===== */
.menu-sidebar-list::-webkit-scrollbar,
.submenu-box::-webkit-scrollbar {
    width: 6px;
}

.menu-sidebar-list::-webkit-scrollbar-track,
.submenu-box::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
}

.menu-sidebar-list::-webkit-scrollbar-thumb,
.submenu-box::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 3px;
}

.menu-sidebar-list::-webkit-scrollbar-thumb:hover,
.submenu-box::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
}

/* ===== RESPONSIVE ===== */
@media (max-width: 992px) {
    .menu-association-layout {
        height: 340px;
        min-height: 340px;
        max-height: 340px;
    }
}

@media (max-width: 768px) {
    .modal-fixed-height .modal-body {
        padding: 16px 12px;
    }

    .menu-association-layout {
        flex-direction: column;
        height: 420px;
        min-height: 420px;
        max-height: 420px;
        gap: 0;
    }

    .menu-sidebar {
        flex: 0 0 auto;
        border-right: none;
        border-bottom: 1px solid #e9ecef;
        max-height: 140px;
        padding: 8px 0;
    }

    .menu-sidebar-list {
        max-height: 100px;
    }

    .menu-sidebar-title {
        padding: 0 12px 8px 12px;
        font-size: 12px;
    }

    .menu-sidebar-item {
        padding: 8px 12px;
        font-size: 13px;
    }

    .menu-content {
        padding: 12px 16px;
        min-height: 200px;
        flex: 1;
    }

    .menu-content-title {
        font-size: 14px;
        padding-bottom: 8px;
        margin-bottom: 8px;
    }

    .submenu-row {
        padding: 6px 8px;
    }

    .submenu-name {
        font-size: 13px;
    }

    .custom-toggle-wrapper .toggle-slider {
        width: 30px;
        height: 18px;
    }

    .custom-toggle-wrapper .toggle-slider::after {
        width: 14px;
        height: 14px;
        top: 2px;
        left: 2px;
    }

    .custom-toggle-wrapper input[type="checkbox"]:checked + .toggle-label .toggle-slider::after {
        transform: translateX(12px);
    }

    .custom-toggle-wrapper .toggle-text {
        font-size: 11px;
        min-width: 42px;
    }

    .custom-toggle-wrapper {
        gap: 6px;
    }

    .custom-toggle-wrapper .toggle-label {
        gap: 5px;
    }

    .uniform-actions-wrap {
        flex-direction: column;
        margin-top: 12px;
        padding-top: 12px;
    }

    .uniform-actions-wrap .reset-btn-secondary {
        width: 100%;
        margin: 4px 0 !important;
    }

    .reset-modal-body {
        padding: 16px 12px;
    }
}

@media (max-width: 576px) {
    .password-policy-box {
        padding: 12px 16px;
    }

    .password-policy-title {
        font-size: 14px;
    }

    .password-policy-subtitle {
        font-size: 13px;
    }

    .menu-association-layout {
        height: 380px;
        min-height: 380px;
        max-height: 380px;
    }

    .menu-sidebar {
        max-height: 120px;
    }

    .menu-sidebar-list {
        max-height: 80px;
    }

    .menu-sidebar-item {
        padding: 6px 12px;
        font-size: 12px;
    }

    .menu-content-title {
        font-size: 13px;
    }

    .submenu-name {
        font-size: 12px;
    }

    .custom-toggle-wrapper .toggle-slider {
        width: 28px;
        height: 16px;
        border-radius: 8px;
    }

    .custom-toggle-wrapper .toggle-slider::after {
        width: 12px;
        height: 12px;
        top: 2px;
        left: 2px;
    }

    .custom-toggle-wrapper input[type="checkbox"]:checked + .toggle-label .toggle-slider::after {
        transform: translateX(12px);
    }

    .custom-toggle-wrapper .toggle-text {
        font-size: 10px;
        min-width: 38px;
    }

    .reset-dialog-actions {
        flex-direction: column;
    }

    .reset-dialog-actions .reset-btn-secondary {
        width: 100%;
        margin: 4px 0 !important;
    }
}
</style>